export default function ready(fn) {
    if (
    // @ts-ignore
    document.attachEvent
        ? document.readyState === 'complete'
        : document.readyState !== 'loading') {
        fn();
    }
    else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}
//# sourceMappingURL=ready.js.map